import React from 'react'
import {Button} from '.'

export const CapGreenButton = p => <Button accent medium {...p} />
export const CapGreenLightButton = p => (
	<Button compact useSet="contrast" {...p} />
)
